module.exports = __webpack_public_path__ + "03_hair_brown.34bf70f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/03_hair_brown.png
// module id = TiMh
// module chunks = 0